var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"double-ranking-title",style:({
        color: _vm.color,
        fontSize: _vm.fontSize,
    })},[_vm._v(" "+_vm._s(_vm.content)+" "+_vm._s(_vm.fullYear)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }